export default __webpack_public_path__ + "static/cambridge-dae0d5e871e98ad5fb3df32ffe0647ac.png";